export default "__VITE_ASSET__DbO2MjZh__"